import axios from "axios";
// const API_URL_Local = "http://172.27.184.102:8100/api/v2/";
const API_URL_Local = process.env.REACT_APP_API_URL
//const API_URL_Local = "https://amethyst.gistda.or.th/api/v2/"
// const API_URL_Local1 = "https://172.27.181.168/api/v2/";
const handleError = (error) => {
  if (error.response) {
    // Error จากการตอบกลับของเซิร์ฟเวอร์
    if(error.response.data.error_description){
      throw error.response.data.error_description
    }else{
      throw "respone error"
    }
    
  } else if (error.request) {
    // Error เกิดขึ้นในระหว่าง request ถูกส่งแต่ไม่ได้รับการตอบกลับ
    console.error("Network Error:", error.request);
    //alert("Network error. Please check your internet connection.");
    throw "Request Error"
  } else {
    // Error จากการตั้งค่าหรืออื่น ๆ
    console.error("Error:", error.message);
    
    //alert(error.message);
    throw "Error Message"
  }
};





const GetAreaData = async (start_time, end_time, center_coordinate) => {
  console.log(start_time,end_time,center_coordinate);
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
  try {
    const response = await axios.post(
      API_URL_Local + "agency/operation-area",
      {
        operation_start_time: start_time,
        operation_end_time: end_time,
        center_coordinate: center_coordinate,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    return response;
  } catch (error) {
    console.log("Error in 'AG47SD' \n", error.response.data.error_description);
    handleError(error);
    throw error.response;
  }}
};
const CheckOperation = async ( time_ID,
  purpose,
  operation_area,
  altitude,
  area_type) => {
  const access_token = sessionStorage.getItem("access_token");
  console.log(time_ID,
    purpose,
    operation_area,
    altitude,
    area_type);
    console.log(typeof(time_ID),
      typeof(purpose),
      typeof(operation_area),
      typeof(altitude),
      typeof(area_type));
      const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
  try {
    const response = await axios.post(
      API_URL_Local + "agency/check-operation",
      {
        time_ID,
        purpose,
        operation_area,
        altitude,
        area_type,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    return response;
  } catch (error) {
    console.log("Error in 'HELLHYDRA' \n", error.response.data.error_description);
    handleError(error);
    throw error.response;
  }}
};

const ConfirmOperation = async (data_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
  try {
    const response = await axios.post(
      API_URL_Local + "agency/confirm-operation",
      {
        data_id,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    return response;
  } catch (error) {
    console.log("Error in 'SEXYGAME66' \n", error.response.data.error_description);
    handleError(error);
    throw error.response;
  }}
};

const CancelSaveOperation = async (data_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
  try {
    const response = await axios.post(
      API_URL_Local + "agency/cancel-operation",
      {
        data_id,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    return response;
  } catch (error) {
    console.log("Error in 'MAGOA888' \n", error.response.data.error_description);
    handleError(error);
    throw error.response;
  }}
};

const Opearationdata = (operationid) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
  if (operationid) {
    return axios
      .get(API_URL_Local + "agency/operation-data", {
        params: { operation_id: operationid },
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        //console.log(response);
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  } else {
    return axios
      .get(API_URL_Local + "agency/operation-data", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })
      .then((response) => {
        //console.log(response);
        return response;
      })
      .catch((err) => {
        console.log(err);
      });
  }}
}

const ResponseOperationRequest = async (operation_co_id, res_status) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if(checktoken != null){
  try {
    const response = await axios.post(
      API_URL_Local + "agency/response-join-operation",
      {
        operation_co_id,
        res_status,
      },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    return response;
  } catch (error) {
    console.log("Error in 'TEENOI168' \n", error.response.data.error_description);
    handleError(error);
    throw error.response;
  }}
};
const Agencyservice = {
  GetAreaData,
  CheckOperation,
  ConfirmOperation,
  CancelSaveOperation,
  Opearationdata,
  ResponseOperationRequest,
};

export default Agencyservice;
